<template>
  <section class="privacy">
    <banner part-id="privacy" />
    <div class="section-text-background privacy-text-background" :style="backgroundTextStyle">贴心守护</div>
    <cloud-infor />
    <codebook />
    <persionalProtection />
    <PrivacyProtectionOversea />
  </section>
</template>

<script>
import Banner from '../Banner/PartBanner';
import CloudInfor from './CloudInfor';

import Codebook from './Codebook';
import PersionalProtection from './PersionalProtection';
import PrivacyProtectionOversea from './PrivacyProtectionOversea';
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';

export default {
  inject: ['vm', 'lang'],
  components: {
    Banner,
    CloudInfor,
    Codebook,
    PersionalProtection,
    PrivacyProtectionOversea
  },
  data() {
    return {
      backgroundTextProgress: 0
    };
  },
  computed: {
    backgroundTextStyle() {
      return {
        transform: `translate3d(0,-${Math.min(1, this.backgroundTextProgress / 0.5) * 300}px,0)`
      };
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: window.innerHeight * 2,
        triggerElement: '.privacy',
        offset: window.innerHeight,
        triggerHook: 0
      })
        .setPin('.privacy-text-background')
        .addTo(Controller)
        .on('progress', e => {
          this.backgroundTextProgress = e.progress;
        });
    },
    resizeHandler() {
      if (window.innerWidth <= 734) {
        this.backgroundTextProgress = 0;
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
        }
      } else if (window.innerWidth > 734 && !this.scene) {
        this.initScroll();
      }
      if (this.scene) this.scene.offset(window.innerHeight).duration(2 * window.innerHeight);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './privacy.scss';
</style>
